import type {OrganizationalUnit} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/organizationalUnitsWorkspaceCapability/domain/OrganizationalUnit";
import type {OrganizationalUnitTemplate} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/organizationalUnitsWorkspaceCapability/domain/OrganizationalUnitTemplate";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {OttopilotAdditionalButtonKind, OttopilotAdditionalButtonFormFieldPresentation, OttopilotAdditionalButtonFormFieldRole, OttopilotOperator, OttopilotRunTimeValueKind, type OttopilotAdditionalButtonVisibilityRule, type OttopilotAdditionalButtonsConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEventAdditionalButtonsConfig";
import {getPathFromLeaf} from "~/utilities/accessControl/ouHierarchyDisplay";
import {
    DHIRAAGU__CUSTOMERS__PHONE_NUMBER_COLUMN_ID,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/Customers";
import {
    CallStatusEnum,
    callStatuses,
    DHIRAAGU__EVENT__CALLS__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_DURATION__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_END_TIME__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_START_TIME__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_TYPE__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CANCELLED_BY__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CANCELLED_ON__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__LOGGED_BY__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__LOGGED_CALL_REMARKS__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__LOGGED_ON__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_TERM__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__AREA__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ATOLL__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__GENDER__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__HOUSE_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ISLAND__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__LANDMARK__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__REGION__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ROCS__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__ACCOUNT_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__STATUS__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_TERM__COLUMN_ID,
    DhiraaguEventTypes,
    EnquiryStatusEnum,
    enquiryStatuses,
    EventCallType,
    lastEventTypes,
    SalesStatusEnum,
    salesStatuses,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/Events";
import {
    DHIRAAGU__EVENT_CONTAINER__AREA__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ATOLL__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CREATE__FORM__ID,
    DHIRAAGU__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__GENDER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__HOUSE_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ISLAND__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LANDMARK__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__REGION__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__REMARKS__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ROCS__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__SALES_COUNT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__STATUS__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_TERM__COLUMN_ID,
    DHIRAAGU_UTM_PLATFORM_OPTIONS,
    DhiraaguEventContainerDispositionEnum,
    dhiraaguEventContainerDispositions,
    GenderEnum,
    genders,
    getDhiraaguEventContainerDispositions,
    EventContainerStatusEnum,
    eventContainerStatuses,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/EventContainers";
import type {
    DhiraaguUtmPlatform,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/EventContainers";
import {
    DHIRAAGU__OU__ATOLLS__ABR__COLUMN_ID,
    DHIRAAGU__OU__ATOLLS__NAME__COLUMN_ID,
    DHIRAAGU__OU__ISLANDS__LAT__COLUMN_ID,
    DHIRAAGU__OU__ISLANDS__LONG__COLUMN_ID,
    DHIRAAGU__OU__ISLANDS__NAME__COLUMN_ID,
    DHIRAAGU__OU__REGIONS__NAME__COLUMN_ID,
    DHIRAAGU__OU__ROCS__CODE__COLUMN_ID,
    DHIRAAGU__OU__ROCS__NAME__COLUMN_ID,
    DHIRAAGU__OU__SHOWROOMS__LAT__COLUMN_ID,
    DHIRAAGU__OU__SHOWROOMS__LONG__COLUMN_ID,
    DHIRAAGU__OU__SHOWROOMS__NAME__COLUMN_ID,
    DHIRAAGU__OU__VIRTUAL_SHOWROOMS__LAT__COLUMN_ID,
    DHIRAAGU__OU__VIRTUAL_SHOWROOMS__LONG__COLUMN_ID,
    DHIRAAGU__OU__VIRTUAL_SHOWROOMS__NAME__COLUMN_ID,
    DhiraaguOus,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/OrganizationalUnits";
import {
    DHIRAAGU__EVENT__CALLS__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__PRODUCT_CATALOGUE__DESCRIPTION__COLUMN_ID,
    DHIRAAGU__PRODUCT_CATALOGUE__NAME__COLUMN_ID,
    DHIRAAGU_PRODUCT_CATALOGUE_TEMPLATE_ID,
    productCategories,
    ProductCategoryEnum,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/ProductCatalogue";
import {
    DHIRAAGU__USER_ANALYST__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__KYC_DETAILS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__NAME__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__ISLANDS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__KYC_DETAILS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__NAME__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__KYC_DETAILS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__NAME__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_BUH__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_BUH__DOB__COLUMN_ID,
    DHIRAAGU__USER_BUH__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_BUH__GENDER__COLUMN_ID,
    DHIRAAGU__USER_BUH__NAME__COLUMN_ID,
    DHIRAAGU__USER_BUH__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_BUH__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_BUH__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_CALLERS__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_CALLERS__NAME__COLUMN_ID,
    DHIRAAGU__USER_CALLERS__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_PARTNERS__NAME__COLUMN_ID,
    DHIRAAGU__USER_PARTNERS__PLATFORM__COLUMN_ID,
    DHIRAAGU__USER_RSM__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_RSM__DOB__COLUMN_ID,
    DHIRAAGU__USER_RSM__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_RSM__GENDER__COLUMN_ID,
    DHIRAAGU__USER_RSM__NAME__COLUMN_ID,
    DHIRAAGU__USER_RSM__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_RSM__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_RSM__REGIONS__COLUMN_ID,
    DHIRAAGU__USER_RSM__ROCS__COLUMN_ID,
    DHIRAAGU__USER_RSM__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_SA__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_SA__DOB__COLUMN_ID,
    DHIRAAGU__USER_SA__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_SA__GENDER__COLUMN_ID,
    DHIRAAGU__USER_SA__NAME__COLUMN_ID,
    DHIRAAGU__USER_SA__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_SA__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_SA__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_SC__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_SC__ATOLLS__COLUMN_ID,
    DHIRAAGU__USER_SC__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_SC__DOB__COLUMN_ID,
    DHIRAAGU__USER_SC__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_SC__GENDER__COLUMN_ID,
    DHIRAAGU__USER_SC__NAME__COLUMN_ID,
    DHIRAAGU__USER_SC__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_SC__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_SC__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_TL__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_TL__DOB__COLUMN_ID,
    DHIRAAGU__USER_TL__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_TL__GENDER__COLUMN_ID,
    DHIRAAGU__USER_TL__ISLANDS__COLUMN_ID,
    DHIRAAGU__USER_TL__NAME__COLUMN_ID,
    DHIRAAGU__USER_TL__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_TL__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_TL__ROCS__COLUMN_ID,
    DHIRAAGU__USER_TL__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_TL__VIRTUAL_SHOWROOMS__COLUMN_ID,
    DHIRAAGU__USER_TSM__ATOLLS__COLUMN_ID,
    DHIRAAGU__USER_TSM__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_TSM__DOB__COLUMN_ID,
    DHIRAAGU__USER_TSM__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_TSM__GENDER__COLUMN_ID,
    DHIRAAGU__USER_TSM__NAME__COLUMN_ID,
    DHIRAAGU__USER_TSM__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_TSM__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_TSM__REGIONS__COLUMN_ID,
    DHIRAAGU__USER_TSM__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DhiraaguRoles,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/Users";
import type {
    DhiraaguUserTemplateColumnIds,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/Users";
import {
    DhiraaguModuleNames,
    ModuleType,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/dhiraagu/Workspace";

export {
    dhiraaguEventContainerDispositions,
    getDhiraaguEventContainerDispositions,
    eventContainerStatuses,
    enquiryStatuses,
    salesStatuses,
    callStatuses,
    productCategories,
    genders,
    lastEventTypes,
    DHIRAAGU_UTM_PLATFORM_OPTIONS,
};
export type {
    DhiraaguUserTemplateColumnIds,
    DhiraaguUtmPlatform,
};
export {
    DHIRAAGU__CUSTOMERS__PHONE_NUMBER_COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__STATUS__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ISLAND__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ATOLL__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__REGION__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ROCS__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__REMARKS__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__GENDER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__HOUSE_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__AREA__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LANDMARK__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__SALES_COUNT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_TERM__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__OU__REGIONS__NAME__COLUMN_ID,
    DHIRAAGU__OU__ROCS__NAME__COLUMN_ID,
    DHIRAAGU__OU__ROCS__CODE__COLUMN_ID,
    DHIRAAGU__OU__ATOLLS__NAME__COLUMN_ID,
    DHIRAAGU__OU__ATOLLS__ABR__COLUMN_ID,
    DHIRAAGU__OU__ISLANDS__LAT__COLUMN_ID,
    DHIRAAGU__OU__ISLANDS__LONG__COLUMN_ID,
    DHIRAAGU__OU__ISLANDS__NAME__COLUMN_ID,
    DHIRAAGU__OU__VIRTUAL_SHOWROOMS__LAT__COLUMN_ID,
    DHIRAAGU__OU__VIRTUAL_SHOWROOMS__LONG__COLUMN_ID,
    DHIRAAGU__OU__VIRTUAL_SHOWROOMS__NAME__COLUMN_ID,
    DHIRAAGU__OU__SHOWROOMS__LAT__COLUMN_ID,
    DHIRAAGU__OU__SHOWROOMS__LONG__COLUMN_ID,
    DHIRAAGU__OU__SHOWROOMS__NAME__COLUMN_ID,
    DHIRAAGU__USER_SA__NAME__COLUMN_ID,
    DHIRAAGU__USER_SA__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_SA__DOB__COLUMN_ID,
    DHIRAAGU__USER_SA__GENDER__COLUMN_ID,
    DHIRAAGU__USER_SA__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_SA__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_SA__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_SA__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_SA__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_BUH__NAME__COLUMN_ID,
    DHIRAAGU__USER_BUH__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_BUH__DOB__COLUMN_ID,
    DHIRAAGU__USER_BUH__GENDER__COLUMN_ID,
    DHIRAAGU__USER_BUH__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_BUH__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_BUH__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_BUH__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_BUH__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_RSM__NAME__COLUMN_ID,
    DHIRAAGU__USER_RSM__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_RSM__DOB__COLUMN_ID,
    DHIRAAGU__USER_RSM__GENDER__COLUMN_ID,
    DHIRAAGU__USER_RSM__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_RSM__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_RSM__REGIONS__COLUMN_ID,
    DHIRAAGU__USER_RSM__ROCS__COLUMN_ID,
    DHIRAAGU__USER_RSM__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_RSM__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_RSM__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_TSM__NAME__COLUMN_ID,
    DHIRAAGU__USER_TSM__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_TSM__DOB__COLUMN_ID,
    DHIRAAGU__USER_TSM__GENDER__COLUMN_ID,
    DHIRAAGU__USER_TSM__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_TSM__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_TSM__ATOLLS__COLUMN_ID,
    DHIRAAGU__USER_TSM__REGIONS__COLUMN_ID,
    DHIRAAGU__USER_TSM__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_TSM__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_TSM__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_TL__NAME__COLUMN_ID,
    DHIRAAGU__USER_TL__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_TL__DOB__COLUMN_ID,
    DHIRAAGU__USER_TL__GENDER__COLUMN_ID,
    DHIRAAGU__USER_TL__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_TL__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_TL__ISLANDS__COLUMN_ID,
    DHIRAAGU__USER_TL__ROCS__COLUMN_ID,
    DHIRAAGU__USER_TL__VIRTUAL_SHOWROOMS__COLUMN_ID,
    DHIRAAGU__USER_TL__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_TL__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_TL__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_SC__NAME__COLUMN_ID,
    DHIRAAGU__USER_SC__DISPLAY_NAME__COLUMN_ID,
    DHIRAAGU__USER_SC__DOB__COLUMN_ID,
    DHIRAAGU__USER_SC__GENDER__COLUMN_ID,
    DHIRAAGU__USER_SC__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_SC__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_SC__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_SC__ATOLLS__COLUMN_ID,
    DHIRAAGU__USER_SC__STAFF_CODE__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_SUBMITTED_ON__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_PROCESSED_ON__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_PROCESSED_BY__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_REJECT_REASON__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_INVITED_AT__COLUMN_ID,
    DHIRAAGU__USER_SC__VERIFICATION_INVITED_BY__COLUMN_ID,
    DHIRAAGU__USER_SC__PROFILE_IMAGE_URL__COLUMN_ID,
    DHIRAAGU__USER_PARTNERS__NAME__COLUMN_ID,
    DHIRAAGU__USER_PARTNERS__PLATFORM__COLUMN_ID,
    DHIRAAGU__USER_CALLERS__NAME__COLUMN_ID,
    DHIRAAGU__USER_CALLERS__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_CALLERS__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__NAME__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST__KYC_DETAILS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__NAME__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__KYC_DETAILS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST1__ISLANDS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__NAME__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__EMAIL__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__PHONE_NUMBER__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__ADDRESS__COLUMN_ID,
    DHIRAAGU__USER_ANALYST2__KYC_DETAILS__COLUMN_ID,
    DhiraaguOus,
    DhiraaguRoles,
    DhiraaguEventTypes,
    EventCallType,
    DhiraaguEventContainerDispositionEnum,
    ModuleType,
    DhiraaguModuleNames,
    DHIRAAGU_PRODUCT_CATALOGUE_TEMPLATE_ID,
    DHIRAAGU__PRODUCT_CATALOGUE__NAME__COLUMN_ID,
    DHIRAAGU__PRODUCT_CATALOGUE__DESCRIPTION__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ISLAND__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ATOLL__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__REGION__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ROCS__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__GENDER__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__HOUSE_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__AREA__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__LANDMARK__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__EVENT__ENQUIRY__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_TYPE__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__LOGGED_CALL_REMARKS__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_START_TIME__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_END_TIME__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CALL_DURATION__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__LOGGED_BY__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__LOGGED_ON__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CANCELLED_BY__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CANCELLED_ON__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_TERM__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__STATUS__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__ACCOUNT_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__PRODUCT_CATALOGUE_ID__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__ASSOCIATED_BEAT__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_PLATFORM__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_SOURCE__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_MEDIUM__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_CAMPAIGN__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_TERM__COLUMN_ID,
    DHIRAAGU__EVENT__SALES__UTM_CONTENT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CREATE__FORM__ID,
    EventContainerStatusEnum,
    EnquiryStatusEnum,
    SalesStatusEnum,
    CallStatusEnum,
    ProductCategoryEnum,
    GenderEnum,
};

// import {getPathFromLeaf} from "~/utilities/ouHierarchyDisplay";

// export const DHIRAAGU_WORKSPACE_ID = "88d2711f-43dc-4e6a-bf59-fdc357a39b63" as Uuid;

export function isDhiraaguWorkspace(workspace: {displayName: string}): boolean {
    return workspace.displayName.toLowerCase().includes("dhiraagu")
        && workspace.displayName.toLowerCase().includes("ottopilot");
}

// Journey Column Constants
// export const DHIRAAGU__EVENT_CONTAINER__DISPOSITION__COLUMN_ID = "6a0a6d4f-1d5c-4a9d-baf7-74fd6b652b41" as Uuid;
// export const DHIRAAGU__EVENT_CONTAINER__CREATED_BY__COLUMN_ID = "350f19d0-9462-40d0-be6f-59c05a73a4be" as Uuid;
// export const DHIRAAGU__EVENT_CONTAINER__CREATED_ON__COLUMN_ID = "cb9e6b1a-7cb6-4928-9194-1ca7d1f5bec5" as Uuid;
// Organizational Unit Column Constants
// Regions OU Column Constants
// ROCs OU Column Constants
// Atolls OU Column Constants

// Islands OU Column Constants

// Virtual Showrooms OU Column Constants

// Showrooms OU Column Constants

// User column constants






export function getIslandOuIdsFromGeographyNodes(
    geographyNodes: Array<{ouTemplateId: Uuid; ouIds: Array<Uuid>}>,
): Array<Uuid> {
    return geographyNodes.flatMap((ele) => {
        if (ele.ouTemplateId === (DhiraaguOus.Islands as Uuid)) {
            return ele.ouIds;
        }
        return [];
    });
}

export function getIslandNamesFromOuIds(
    ouIds: Array<Uuid | string>,
    organizationalUnits: Array<OrganizationalUnit>,
): Array<string> {
    if (ouIds.length === 0) {
        return [];
    }
    return ouIds.map((ouId) => {
        const ou = organizationalUnits.find((unit) => unit.id === ouId);
        const islandName = ou?.additionalColumnValues[DHIRAAGU__OU__ISLANDS__NAME__COLUMN_ID];
        if (typeof islandName === "string") {
            return islandName;
        }
        return String(ouId);
    });
}

export function getIslandNameFromGeographyNodes(
    geographyNodes: Array<{ouTemplateId: Uuid; ouIds: Array<Uuid>}>,
    organizationalUnits: Array<OrganizationalUnit>,
): string {
    const islandIds = getIslandOuIdsFromGeographyNodes(geographyNodes);
    if (islandIds.length === 0) {
        return "-";
    }
    const names = getIslandNamesFromOuIds(islandIds, organizationalUnits);
    return names.join(", ");
}

export function getDhiraaguJourneyOuValuesFromLeaf(
    leafOuId: Uuid,
    organizationalUnits: Array<OrganizationalUnit>,
    organizationalUnitTemplates: Array<OrganizationalUnitTemplate>,
): Record<Uuid, Uuid> {
    const path = getPathFromLeaf(
        leafOuId,
        organizationalUnits,
        organizationalUnitTemplates,
    );
    const result: Record<Uuid, Uuid> = {};

    for (const entry of path) {
        if (entry.templateId === (DhiraaguOus.Regions as Uuid)) {
            result[DHIRAAGU__EVENT_CONTAINER__REGION__COLUMN_ID] = entry.ouId;
        } else if (entry.templateId === (DhiraaguOus.ROCs as Uuid)) {
            result[DHIRAAGU__EVENT_CONTAINER__ROCS__COLUMN_ID] = entry.ouId;
        } else if (entry.templateId === (DhiraaguOus.Atolls as Uuid)) {
            result[DHIRAAGU__EVENT_CONTAINER__ATOLL__COLUMN_ID] = entry.ouId;
        } else if (entry.templateId === (DhiraaguOus.Islands as Uuid)) {
            result[DHIRAAGU__EVENT_CONTAINER__ISLAND__COLUMN_ID] = entry.ouId;
        }
    }

    return result;
}

// Journey Disposition Enum
/** Product catalogue template UUID — per-template item table in workspace DB. Match workspaceCreation dhiraagu config. */

/** Workspace-seeding helper object — mirrors legacy enum used by `ottopilot--scripts` workspace config. */
export const DhiraaguProductCatalogues = {
    ProductCatalogue: DHIRAAGU_PRODUCT_CATALOGUE_TEMPLATE_ID,
} as const;


// Enquiry Event Column Constants

// Calls Event Column Constants

// Sales Event Column Constants
// export const DHIRAAGU__EVENT__SALES__CREATED_BY__COLUMN_ID = "e7335c2d-264d-430e-832c-9c1988a6faeb" as Uuid;

// Form IDs

/**
 * Returns true when the journeys module is configured as the Dhiraagu journey module
 * (e.g. uses Dhiraagu create form and journey behaviour).
 */
export function isDhiraaguJourneyModuleConfiguration(config: {
    eventContainersPage: { writeConfig?: { formId: Uuid } };
}): boolean {
    return config.eventContainersPage.writeConfig?.formId === DHIRAAGU__EVENT_CONTAINER__CREATE__FORM__ID;
}

export const DHIRAAGU__EVENT_CONTAINER__EDIT__FORM__ID = "8d4f5b2f-ac3e-5g9b-b6d7-3e2f9ga4d5b" as Uuid;
export const DHIRAAGU__CALL__SCHEDULE__FORM__ID = "9e5g6c3g-bd4f-6h0c-c7e8-4f3gah5e6c" as Uuid;
export const DHIRAAGU__CALL__LOG__FORM__ID = "af6h7d4h-ce5g-7i1d-d8f9-5g4hbi6f7d" as Uuid;
export const DHIRAAGU__CALL__EDIT__FORM__ID = "bg7i8e5i-df6h-8j2e-e9ga-6h5icj7g8e" as Uuid;
export const DHIRAAGU__SALES__CREATE__FORM__ID = "ch8j9f6j-eg7i-9k3f-fahb-7i6jdk8h9f" as Uuid;
export const DHIRAAGU__SALES__EDIT__FORM__ID = "di9ka7k-fh8j-al4g-gbic-8j7kel9ia" as Uuid;

// Journey Status Enum
// Enquiry Status Enum
// Sales Status Enum
// Call Status Enum
const dhiraaguCallScheduledVisibilityRule: OttopilotAdditionalButtonVisibilityRule = {
    conditions: [
        {
            attribute: DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID,
            operator: OttopilotOperator.equals,
            kind: OttopilotRunTimeValueKind.static,
            value: CallStatusEnum.SCHEDULED as string,
        },
    ],
    logicalOperator: "and",
};

export const DHIRAAGU__CALL_EVENT__ADDITIONAL_BUTTONS: Array<OttopilotAdditionalButtonsConfig> = [
    {
        id: "d4c3b2a1-9e8f-4d7c-b6a5-4f3e2d1c0b9a" as Uuid,
        label: "Cancel call",
        buttonKind: OttopilotAdditionalButtonKind.cancel,
        rules: [dhiraaguCallScheduledVisibilityRule],
        showModal: true,
        formColumnData: [
            {
                columnId: DHIRAAGU__EVENT__CALLS__CANCELLED_BY__COLUMN_ID,
                columnType: "OttopilotEvent",
                isVisible: false,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.user,
                sortOrder: 0,
            },
            {
                columnId: DHIRAAGU__EVENT__CALLS__CANCELLED_ON__COLUMN_ID,
                columnType: "OttopilotEvent",
                isVisible: false,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.timestamp,
                sortOrder: 1,
            },
            {
                columnId: DHIRAAGU__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID,
                columnType: "OttopilotEvent",
                fieldRole: OttopilotAdditionalButtonFormFieldRole.cancelRemarks,
                isVisible: true,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.static,
                presentation: OttopilotAdditionalButtonFormFieldPresentation.multiLineText,
                sortOrder: 2,
            },
            {
                columnId: DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID,
                columnType: "OttopilotEvent",
                isVisible: false,
                isRequired: true,
                kind: OttopilotRunTimeValueKind.static,
                defaultValue: CallStatusEnum.CANCELLED as string,
                sortOrder: 3,
            },
        ],
    },
    {
        id: "c3b2a190-8d7e-4c6b-a594-3e2d1c0b9a8f" as Uuid,
        label: "Log call",
        buttonKind: OttopilotAdditionalButtonKind.log,
        rules: [dhiraaguCallScheduledVisibilityRule],
        formUrl: "dhiraagu/call/log",
        formUrlQueryParams: ["eventContainerId", "eventId"],
    },
];

// Product Category Enum
// Gender Enum
// Last Event Types (for tracking last activity on journey)
// Uses the same UUIDs as DhiraaguEventTypes
// export const DHIRAAGU_DEFAULT_JOURNEY_TRIGGER_CONFIG: TriggerConfig = [
//     {
//         type: Trigger.dateTimeTrigger,
//         eventTemplateId: DhiraaguEventTypes.call as Uuid,
//         triggerDispositions: [
//             dhiraaguEventContainerDispositions[DhiraaguEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER].id,
//         ],
//         dataColumns: [
//             {
//                 columnId: DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID,
//                 columnType: "OttopilotEvent",
//                 driver: TriggerDataDriver.staticDefault,
//                 defaultValue: CallStatusEnum.SCHEDULED,
//             },
//             {
//                 columnId: DHIRAAGU__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
//                 columnType: "OttopilotEvent",
//                 driver: TriggerDataDriver.workspaceUser,
//             },
//             {
//                 columnId: DHIRAAGU__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
//                 columnType: "OttopilotEvent",
//                 driver: TriggerDataDriver.staticDefault,
//                 defaultValue: null,
//             },
//             {
//                 columnId: DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
//                 columnType: "OttopilotEventContainer",
//                 driver: TriggerDataDriver.staticDefault,
//                 defaultValue: DhiraaguEventTypes.call as Uuid,
//             },
//             {
//                 columnId: DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
//                 columnType: "OttopilotEventContainer",
//                 driver: TriggerDataDriver.currentTimestamp,
//             },
//         ],
//         dateTimeColumnId: DHIRAAGU__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
//         scheduleFieldLabel: "Schedule call",
//         scheduleValueEncoding: ScheduleValueEncoding.iso8601Instant,
//     },
// ];

// export const dhiraaguDispositionConfig: DispositionConfig = {
//     emitWhen: DispositionEmitWhen.pathMatchesKnownDisposition,
//     plugins: [
//         {
//             kind: DispositionPluginKind.dispositionHistory,
//             lastN: 20,
//         },
//         {
//             kind: DispositionPluginKind.optionRules,
//             rules: [
//                 {
//                     id: "dhiraagu-hide-not-reachable-after-6",
//                     when: {
//                         level: 1,
//                         selectedPrefix: ["not-connected"],
//                     },
//                     targetSegment: "not-reachable",
//                     countDispositionId: dhiraaguEventContainerDispositions[
//                         DhiraaguEventContainerDispositionEnum.NOT_CONNECTED_NOT_REACHABLE
//                     ].id,
//                     countMode: DispositionOptionRuleCountMode.totalInHistory,
//                     action: {
//                         kind: DispositionOptionRuleActionKind.hideWhenCountGte,
//                         max: 6,
//                     },
//                 },
//                 {
//                     id: "dhiraagu-label-not-reachable-count",
//                     when: {
//                         level: 1,
//                         selectedPrefix: ["not-connected"],
//                     },
//                     targetSegment: "not-reachable",
//                     countDispositionId: dhiraaguEventContainerDispositions[
//                         DhiraaguEventContainerDispositionEnum.NOT_CONNECTED_NOT_REACHABLE
//                     ].id,
//                     countMode: DispositionOptionRuleCountMode.totalInHistory,
//                     action: {
//                         kind: DispositionOptionRuleActionKind.setLabelWhenCountLt,
//                         max: 6,
//                         labelTemplate: "{segment} ({countNext})",
//                     },
//                 },
//             ],
//         },
//         {
//             kind: DispositionPluginKind.suggestedJourneyStatusRules,
//             dispositionStatusColumnId: DHIRAAGU__EVENT_CONTAINER__STATUS__COLUMN_ID,
//             rules: [
//                 {
//                     kind: SuggestedJourneyStatusRuleKind.dispositionIdWithConsecutiveHistory,
//                     triggerDispositionId: dhiraaguEventContainerDispositions[
//                         DhiraaguEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER
//                     ].id,
//                     countDispositionId: dhiraaguEventContainerDispositions[
//                         DhiraaguEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER
//                     ].id,
//                     consecutiveMin: 3,
//                     suggested: EventContainerStatusEnum.CHURNED as unknown as Uuid,
//                 },
//                 {
//                     kind: SuggestedJourneyStatusRuleKind.dispositionIdInSet,
//                     dispositionIds: [
//                         dhiraaguEventContainerDispositions[DhiraaguEventContainerDispositionEnum.NOT_CONNECTED_DEAD_LEAD].id,
//                         dhiraaguEventContainerDispositions[
//                             DhiraaguEventContainerDispositionEnum.CONNECTED_INVALID_LEAD_DID_NOT_FILL_DEAD_LEAD
//                         ].id,
//                         dhiraaguEventContainerDispositions[
//                             DhiraaguEventContainerDispositionEnum.CONNECTED_INVALID_LEAD_FILLED_BY_MISTAKE_DEAD_LEAD
//                         ].id,
//                     ],
//                     suggested: EventContainerStatusEnum.CHURNED as unknown as Uuid,
//                 }
//             ],
//         },
//     ],
// };
